import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Paper,
  Stack,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const Contact = ({ header = true }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    busniess: "",
    needType: "staffing",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Add your form submission logic here
  };

  // Hero Section with Page Title
  const HeroSection = () => (
    <Box
      sx={{
        background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
        color: "white",
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 900,
            fontSize: { xs: "2rem", md: "2.4rem" },
          }}
        >
          Contact Us
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 1,
            opacity: 0.95,
            fontSize: { xs: "0.95rem", md: "1.1rem" },
          }}
        >
          Get in touch with our team to discuss your staffing and project needs
        </Typography>
      </Container>
    </Box>
  );

  // Main Contact Section
  const MainContactSection = () => (
    <Box sx={{ py: { xs: 8, md: 10 }, bgcolor: "background.paper" }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="flex-start">
          {/* Left Column - Info */}
          <Grid item xs={12} md={5}>
            <Box>
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, mb: 2, mt: 1, color: "#0D47A1" }}
              >
                Need our help?
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  mb: 2,
                  color: "#2a5298",
                  fontSize: { xs: "1.3rem", md: "2rem" },
                }}
              >
                We want to hear from you!
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  mb: 4,
                  lineHeight: 1.8,
                  fontWeight: 600,
                  color: "text.secondary",
                  fontSize: { xs: "0.95rem", md: "1rem" },
                }}
              >
                With over ten years serving Fortune 1000 and mid-sized clients
                with their data science, app dev and cloud science needs, we are
                sure we can help you! Call us or use the form on the right to
                expedite your request.
              </Typography>

              {/* Contact Info Cards */}
              <Stack spacing={3} sx={{ mt: 5 }}>
                {/* Address */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      bgcolor: "#e3f2fd",
                      flexShrink: 0,
                    }}
                  >
                    <LocationOnIcon sx={{ color: "#2a5298", fontSize: 24 }} />
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        mb: 0.5,
                        fontSize: "1.15rem",
                      }}
                    >
                      Office Address
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      fontWeight="600"
                      fontSize="16px"
                      sx={{ lineHeight: 1.6 }}
                    >
                      34 N Franklin Ave Ste 687-1677
                      <br />
                      Pinedale, WY 82941
                    </Typography>
                  </Box>
                </Box>

                {/* Phone */}
                {/* <Box sx={{ display: "flex", gap: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      bgcolor: "#e3f2fd",
                      flexShrink: 0,
                    }}
                  >
                    <PhoneIcon sx={{ color: "#2a5298", fontSize: 24 }} />
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        mb: 0.5,
                        fontSize: "1rem",
                      }}
                    >
                      Phone
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      +1 (XXX) XXX-XXXX
                    </Typography>
                  </Box>
                </Box> */}

                {/* Email */}
                {/* <Box sx={{ display: "flex", gap: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 50,
                      height: 50,
                      borderRadius: "50%",
                      bgcolor: "#e3f2fd",
                      flexShrink: 0,
                    }}
                  >
                    <EmailIcon sx={{ color: "#2a5298", fontSize: 24 }} />
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        mb: 0.5,
                        fontSize: "1rem",
                      }}
                    >
                      Email
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      contact@alphaforce.com
                    </Typography>
                  </Box>
                </Box> */}
              </Stack>
            </Box>
          </Grid>

          {/* Right Column - Contact Form */}
          <Grid item xs={12} md={7}>
            <Paper
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: 2,
                bgcolor: "#f5f7fa",
                boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  fontSize: { xs: "1.3rem", md: "1.75rem" },
                  color: "#0D47A1",
                }}
              >
                Reach Out To Us!
              </Typography>

              <Typography
                variant="body2"
                color="text.secondary"
                fontWeight="600"
                sx={{ mb: 3, lineHeight: 1.6 }}
              >
                We work with Fortune 1000 and mid sized organizations with their
                data science, app dev and cloud science needs. How can we help
                you?
              </Typography>

              <form onSubmit={handleSubmit}>
                {/* Name Row */}

                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Name"
                  size="small"
                  fontWeight="600"
                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                    },
                  }}
                  required
                />
                {/* busniess */}
                <TextField
                  fullWidth
                  label="Busniess"
                  name="busniess"
                  value={formData.busniess}
                  onChange={handleInputChange}
                  placeholder="Your Company"
                  size="small"
                  fontWeight="600"

                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                    },
                  }}
                />
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="your@email.com"
                  size="small"
                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                    },
                  }}
                  required
                />

                <TextField
                  fullWidth
                  label="Phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="(XXX) XXX-XXXX"
                  size="small"
                  fontWeight="600"

                  sx={{
                    mb: 2,
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                    },
                  }}
                />

                {/* Need Type Selection */}
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    color: "#0D47A1",
                    fontSize: "16px"
                  }}
                >
                  Do you have a staffing or project need?
                </Typography>

                <Stack direction="row" spacing={1} sx={{ mb: 3 }}>
                  <Button
                    variant={
                      formData.needType === "staffing"
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, needType: "staffing" }))
                    }
                    sx={{ flex: 1, fontWeight: 600, fontSize: "15px" }}
                  >
                    Staffing
                  </Button>
                  <Button
                    variant={
                      formData.needType === "projects"
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, needType: "projects" }))
                    }
                    sx={{ flex: 1, fontWeight: 600, fontSize: "15px" }}
                  >
                    Projects
                  </Button>
                </Stack>

                {/* Message */}
                <TextField
                  fullWidth
                  label="Comments"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Tell us more about your needs..."
                  multiline
                  rows={4}
                  sx={{
                    mb: 3,
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                    },
                  }}
                />

                {/* Submit Button */}
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={handleSubmit}
                  sx={{
                    fontWeight: 500,
                    py: 1.5,
                    backgroundColor: "#2a5298",
                    "&:hover": {
                      backgroundColor: "#1e3c72",
                    },
                  }}
                >
                  Send Message
                </Button>
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );

  // Additional Info Section
  const InfoSection = () => (
    <Box sx={{ py: { xs: 6, md: 8 }, bgcolor: "#f5f7fa" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 800,
                  mb: 2,
                  color: "#2a5298",
                }}
              >
                Why Choose AlphaForce?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  color: "text.secondary",
                }}
              >
                With over a decade of experience in staffing and project
                services, AlphaForce has built a reputation for excellence. We
                understand your business needs and connect you with the right
                talent.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 800,
                  mb: 2,
                  color: "#2a5298",
                }}
              >
                Quick Response Time
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  color: "text.secondary",
                }}
              >
                Our team is dedicated to responding to your inquiries promptly.
                We believe in building long-term partnerships with our clients
                based on trust and reliability.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );

  return (
    <Box>
      {header && <HeroSection />}
      <MainContactSection />
      {/* <InfoSection /> */}
    </Box>
  );
};

export default Contact;
